import React from 'react';

function Mute () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      transform="rotate(90)"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.51 5.5C18.893 6.664 19.5 8 19.5 9.654c0 2.346-.717 3.383-1.99 4.846M16 8c.692.56 1.047 1.274.995 2 .052.726-.303 1.44-.995 2"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.172 7H2.6a2.35 2.35 0 00-1.44.472C.76 7.785.5 8.24.5 8.75v2.5c0 .51.26.965.66 1.278A2.35 2.35 0 002.6 13h2.352l5.43 4.182a.505.505 0 00.057.038 2.223 2.223 0 001.882.13c.324-.122.614-.322.827-.587.123-.154.217-.326.277-.51L4.172 7zm9.328 3.671V4.195a1.543 1.543 0 00-.273-.906 1.852 1.852 0 00-.77-.637 2.222 2.222 0 00-1.887.128.495.495 0 00-.053.034l-2.78 2.094L13.5 10.67z"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M1 1l18 18"
      />
    </svg>
  );
}

export default Mute;
